import logo from './logo.svg';
import './App.css';
import About from './Pages/About/About';
import Layout from './Layout/Layout';
import { useRoutes } from "react-router-dom";
import { useState } from 'react';
import PrivateRoute from './routes/PrivateRoute';
import LayoutLogin from './Layout/LayoutLogin';
import AdminLayout from './Layout/AdminLayout';
import Home from './Pages/Home/Home';
import Login from './Pages/Login/Login';
import ReadMore from './Pages/Read/ReadMore';
import Registr from './Pages/Registr/Registr';
import Product from './Pages/Product';
import Layout2 from './Layout/Layout2';
import Contact from './Pages/Contact/Contact';
import Shop from './Pages/Shop/Shop';
import WishList from './Pages/WishList/WishList';
import Basket from './Pages/Basket/Basket';
import Forget from './Pages/Forget/Forget';
import Myaccount from './Pages/Myaccount/Myaccount';
import User from './Pages/User/User';
import Category from './AdminPanel/Category';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'; // Toastify üçün CSS

function App() {
  const [isauth, setAuth] = useState(false);

  let element = useRoutes([
    {
      path: '/',
      element: <Layout />,
      children: [
        {
          path: '/',
          element: <Home />,
        },
      ],
    },
    {
      path: '/',
      element: <Layout2 />,
      children: [
        {
          path: '/about',
          element: <About />,
        },
        {
          path: '/contact',
          element: <Contact />,
        },
        {
          path: "/shop",
          element: <Shop />,
        },
        {
          path: '/wishlist',
          element: <WishList />,
        },
        {
          path: '/basket',
          element: <Basket />,
        },
        {
          path: 'myaccount',
          element: <Myaccount />,
        },
        {
          path: '/product/:id',
          element: <ReadMore />,
        },
        {
          path: "/user",
          element: <User />,
        },
        {
          path: "/category",
          element: <Category />,
        },
      ],
    },
    {
      path: '/',
      element: <LayoutLogin />,
      children: [
        {
          path: "/login",
          element: <Login />,
        },
        {
          path: "/registr",
          element: <Registr />,
        },
        {
          path: "/forget",
          element: <Forget />,
        },
      ],
    },
    {
      path: '/admin',
      element: <AdminLayout />,
      children: [
        {
          path: "/admin",
          element: <Category />,
        },
       
      ],
    },
  ]);

  return (
    <>
      <ToastContainer position="top-right" autoClose={3000} />
      {element}
    </>
  );
}

export default App;
